module.exports = __webpack_public_path__ + "static/media/carwithoutwheels.e6da60a6.png";